<template>
  <div class="pc">
    <div class="pcLogo">
      <!-- <img src="https://p3.ssl.qhimg.com/t11b673bcd622fcc5d773e8ba67.png" alt="" />
      <div class="pcLogoTitle">
        <div class="pcLogoTitleName">ISC·AI 2024</div>
        <div class="pcLogoTitleDesc">第十二届互联网安全大会</div>
      </div> -->
      <img src="https://p1.ssl.qhimg.com/t11b673bcd6ee36076b813e8101.png" alt="" class="pcLogoImg">
    </div>
    <img src="https://p0.ssl.qhimg.com/t11b673bcd695e2eec4769786a7.png" alt="" class="pcHeader">
    <!-- <div class="pcHeader"></div> -->
    <div class="pcBrand">
      <div class="pcBrandTitle">
        <img src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png" alt="" />
        <!-- <div class="pcBrandTitleBlock"></div> -->
        <div class="pcBrandTitleText">{{ obj.brandChange?.title }}</div>
      </div>
      <div class="pcBrandDesc">{{ obj.brandChange?.descOne }}</div>
      <div class="pcBrandDesc pcBrandDescTwo">{{ obj.brandChange?.descTwo }}</div>
      <img class="bgcImg" src="https://p0.ssl.qhimg.com/t11b673bcd6104787796d9220da.png" alt="Sample Image" />
      <!-- <div
        class="scrollable-div"
        @mouseenter="onMouseEnter"
        @mousemove="onMouseMove"
        @mouseleave="onMouseLeave"
        ref="scrollContainer"
      >
        <img src="https://p2.ssl.qhimg.com/t11b673bcd649ab295b5f1bd2c6.png" alt="Sample Image" />
      </div> -->
      <div class="pcBrandDetail">
        <div v-for="(item, index) in obj.brandChange?.details" class="pcBrandDetailItem">
          <img
            src="https://p4.ssl.qhimg.com/t01d65004d0aff8c81f.png"
            alt=""
            class="pcBrandDetailItemImg"
          />
          <div class="pcBrandDetailItemInfo">
            <div class="pcBrandDetailItemInfoTitle">{{ item.name }}</div>
            <div class="pcBrandDetailItemInfoDesc">{{ item.info }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pcApp">
      <div class="pcAppHead">
        <img src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png" alt="" />
        <div class="pcAppTitle">{{ obj.aiApp?.title }}</div>
      </div>
      <div class="pcAppDesc">{{ obj.aiApp?.desc }}</div>
      <div class="pcAppInfo">
        <div v-for="(item, index) in obj.aiApp?.children" :key="index" class="pcAppInfoItem">
          <img :src="item.icon" alt="" />
          <div class="pcAppInfoItemTitle">{{ item.name }}</div>
          <div class="pcAppInfoItemDesc">{{ item.detail }}</div>
        </div>
      </div>
      <img @click="openAppQues" src="https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png" alt="" class="pcAppBtn" />
    </div>
    <div class="pcSafe">
      <div class="pcSafeHead">
        <img class="pcSafeHeadIcon" src="https://p3.ssl.qhimg.com/t01e6cf92549ee92b7d.png" alt="" />
        <div class="pcSafeHeadTitle">{{ obj.aiGlobal?.title }}</div>
      </div>
      <div class="pcSafeDesc">{{ obj.aiGlobal?.desc }}</div>
      <div class="pcSafeInfo">
        <div v-for="(item, index) in obj.aiGlobal?.children" class="pcSafeInfoItem">
          <div class="pcSafeInfoItemHead">
            <img
              src="https://p4.ssl.qhimg.com/t01d65004d0aff8c81f.png"
              alt=""
              class="pcSafeInfoItemHeadIcon"
            />
            <div class="pcSafeInfoItemHeadText">{{ item.name }}</div>
          </div>
          <div class="pcSafeInfoItemBody">
            {{ item.detail }}
          </div>
        </div>
      </div>
      <div class="pcSafeProcess">
        <div class="pcSafeProcessItem">
          <div class="pcSafeProcessItemBox">
            <img :src="obj.aiGlobal?.iconArr[0].icon" alt="" class="pcSafeProcessItemBoxImg" />
          </div>
          <div class="pcSafeProcessItemText">{{ obj.aiGlobal?.iconArr[0].info }}</div>
        </div>
        <img class="arrow" src="https://p1.ssl.qhimg.com/t01d0122f21f29c27a7.png" alt="" />
        <div class="pcSafeProcessItem">
          <div class="pcSafeProcessItemBox">
            <img :src="obj.aiGlobal?.iconArr[1].icon" alt="" class="pcSafeProcessItemBoxImg" />
          </div>
          <div class="pcSafeProcessItemText">{{ obj.aiGlobal?.iconArr[1].info }}</div>
        </div>
        <img class="arrow" src="https://p1.ssl.qhimg.com/t01d0122f21f29c27a7.png" alt="" />
        <div class="pcSafeProcessItem">
          <div class="pcSafeProcessItemBox">
            <img :src="obj.aiGlobal?.iconArr[2].icon" alt="" class="pcSafeProcessItemBoxImg" />
          </div>
          <div class="pcSafeProcessItemText">{{ obj.aiGlobal?.iconArr[2].info }}</div>
        </div>
        <img class="arrow" src="https://p1.ssl.qhimg.com/t01d0122f21f29c27a7.png" alt="" />
        <div class="pcSafeProcessItem">
          <div class="pcSafeProcessItemBox specialBox">
            <img :src="obj.aiGlobal?.iconArr[3].icon" alt="" class="pcSafeProcessItemBoxImg" />
          </div>
          <div class="pcSafeProcessItemText specialText">{{ obj.aiGlobal?.iconArr[3].info }}</div>
        </div>
      </div>
      <img @click="openSafeQues" src="https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png" alt="" class="pcSafeBtn" />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getRecruit } from '@/api/2024/index'

// const obj = ref({
//   brandChange: {
//     title: '品牌蜕变',
//     descOne:
//       '当前，AI大模型应用浪潮奔涌，为拥抱AI高速发展带来的诸多巨变，第十二届互联网安全大会（以下简称“ISC.AI 2024”）全面启动，正式升级为ISC.AI2024，将于7月31日-8月1日在北京国家会议中心召开，开启“聚变元年”。',
//     descTwo:
//       '本届大会将深度聚焦AI与安全两大领域，打造集行业前瞻对话、高峰技术研讨、先进成果展示、创新孵化大赛、产业人才培训于一体的全球首个安全+AI“聚”会，探索“用AI做安全”和“让AI更安全”全球前沿命题，助力数字安全与AI领域的共融创生与跃迁升级，助推新质生产力发展。',
//     details: [
//       {
//         name: '双域扩维探索数智共荣',
//         info: '本届大会开创双域扩维新模式，一域将以“AI赋能数字安全”为出发点，共话AI时代下安全新发展，探索安全大模型在不同场景下的实战应用，及各类大模型安全问题新解法。一域以“AI赋能数转智改”为出发点，探索AI大模型在金融、能源、教育等行业的垂直解决方案，发掘办公、生活等多场景下的多模态应用。'
//       },
//       {
//         name: '产教赋能打破人才瓶颈',
//         info: '本届大会将联合ISC数字安全生态联盟、GPT产业联盟等合作伙伴，基于“AI+安全”两大赛道，分享技术应用，搭建特色展区，为安全及服务、AI大模型技术场景输送资源，助力挖掘出更多商业机会和发展空间；同时通过加强政府、企业、高等院校、科研院所等多方交流，大会将构建融合发展的产业生态体系。'
//       },
//       {
//         name: '生态聚力发掘行业增量',
//         info: '本届大会将以人才教培为核心，打造ISC学院训练营、ISC特色大讲堂、产教成果展等特色活动。将围绕AI大模型与数字安全输出专项培训课程，打造“讲、培、训、练”一体化正循环人才培养体系；更有知名企业家、高校名师现场直播公开课，高维战略、必修技术、创业成长等热门话题一网打尽。'
//       },
//       {
//         name: '数字体验推动AI创生',
//         info: '本届大会将打造数字安全生态展区、AI体验馆、AI生态展区、AI艺术展、赛博文化街等特色活动，并以领先的数智化能力重塑会前、会中、会后的全流程周期。通过不同场景的多触点布局，保障全域参会观众需求的精准触达，为千万级观众打造出数实场景深度融合、交互体验多维立体的沉浸式参会体验。'
//       }
//     ]
//   },
//   aiApp: {
//     title: 'AI应用招募',
//     desc: '为保证大会的含“AI”量，大会将致力推动人工智能从感知走向认知、从识别走向生成、从专用走向通用，展现当下大模型赋能各行各业的多元生态，让大众现场体会技术切实的魅力。',
//     children: [
//       {
//         icon: 'https://p4.ssl.qhimg.com/t01a68f7966ff16da14.png',
//         name: '数字人招募',
//         detail:
//           '大会将联合产业合作伙伴共建虚拟人生态平台，招募厂商将提供数字员工、数字主持人、数字客服等AI虚拟人应用，能够随时随地为观众提供展会问题解答、呈现观展指引等一站式智能服务。 '
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t01ee68c0aaa7ff1ca4.png',
//         name: '数字场景类招募',
//         detail:
//           '大会将基于数字场景类大模型技术构建聚拢行业厂商和创新产品的窗口，招募厂商将支持各类数字论坛、AI展厅&展会、数字应用体验品等特色活动的落地，打造冲击感官的沉浸式体验。'
//       },
//       {
//         icon: 'https://p2.ssl.qhimg.com/t0130f8326ceddd60dd.png',
//         name: 'AI工具类招募',
//         detail:
//           '大会将为观众提供各类AI工具，招募厂商将提供包括但不限于智能翻译，智能同传，大模型会议向导，会议内容总结等AI能力，助力提升本次大会的办会效率与观众的逛会体验。'
//       }
//     ],
//     btnImg: 'https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png'
//   },
//   aiGlobal: {
//     title: '全球AI+安全议题招募',
//     desc: 'ISC互联网安全大会是全球规格最高、规模最大、覆盖最广、影响力最深远的安全峰会之一，自2013年肇始迄今累计设立超600场分论坛，输出超4500个行业前沿议题，吸引来自全球30多个国家的2000余位政要、行业领袖、专家学者的深度参与，被誉为中国网络安全产业名片、全球网络安全行业风向标。为进一步推动AI大模型与数字安全的高质量发展，本届大会将面向全球展开议题征集。',
//     children: [
//       {
//         name: '数字安全议题征集',
//         detail:
//           '本次征集既关注了当下AI赋能数字安全发展的落地实践，也聚焦了AIGC人工智能、量子计算等新兴技术澎湃发展背后的前瞻安全问题，并同时兼顾了全球网络空间对抗下的实战攻防、威胁情报、漏洞挖掘等传统业务安全的关键能力，将以此激发出的AI+安全融合发展的思想大繁荣。'
//       },
//       {
//         name: 'AI大模型议题征集',
//         detail:
//           '本次AI大模型议题征集则聚焦AI大模型对于全行业发展的深远影响，既关注金融、能源、教育等核心关键行业的细分垂直应用，也致力探索多场景、多模态的全新解决方案，助力AI大模型技术与业务的融合发展。'
//       }
//     ],
//     iconArr: [
//       {
//         icon: 'https://p0.ssl.qhimg.com/t0153d38c840b0a2f4f.png',
//         info: '提交报名'
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t015c8402c2cd424e93.png',
//         info: '议题评审'
//       },
//       {
//         icon: 'https://p0.ssl.qhimg.com/t010930eb71776a4e9b.png',
//         info: '结果公示'
//       },
//       {
//         icon: 'https://p1.ssl.qhimg.com/t01d4366f7f36a61ae4.png',
//         info: 'ISC.AI 2024主题演讲'
//       }
//     ],
//     btnImg: 'https://p4.ssl.qhimg.com/t11b673bcd6b652f2e69284526c.png'
//   }
// })

const obj = ref({})

onBeforeMount(async () => {
  await fetch()
})

function openAppQues() {
  const url = 'https://wenjuan.lap.360.cn/sv/j3ol4132asavh'; // 你想要打开的链接
  window.open(url, '_blank'); // _blank 指定在新窗口中打开链接
}

function openSafeQues() {
  const url = 'https://wenjuan.lap.360.cn/sv/qdq98kk6ey8zx'; // 你想要打开的链接
  window.open(url, '_blank'); // _blank 指定在新窗口中打开链接
}

function fetch() {
  getRecruit('SDRMejc5bUluN0h6NGV6Q0ZISEo4QT09Ojq0u0voSpe8Welb3YCLl3nS')
    .then((res) => {
      obj.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})
}

// const isDragging = ref(false)
// const startX = ref(0)
// const scrollLeft = ref(0)
// const scrollContainer = ref(null)

// const onMouseEnter = (e) => {
//   isDragging.value = true
//   startX.value = e.pageX - scrollContainer.value.offsetLeft
//   scrollLeft.value = scrollContainer.value.scrollLeft
// }

// const onMouseMove = (e) => {
//   if (!isDragging.value) return
//   e.preventDefault()
//   const x = e.pageX - scrollContainer.value.offsetLeft
//   const walk = (x - startX.value) * 2 // 乘以2可以增加拖动的速度
//   scrollContainer.value.scrollLeft = scrollLeft.value - walk
// }

// const onMouseLeave = () => {
//   isDragging.value = false
// }

// const onMouseUp = () => {
//   isDragging.value = false
// }

// // 添加一个全局的 mouseup 事件监听器，以防止鼠标在离开元素时未释放
// document.addEventListener('mouseup', onMouseUp)
</script>

<style lang="scss" scoped>
.bgcImg {
  width: 993px;
}
.pc {
  .scrollable-div {
    width: 993px;
    // height: 577px;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    cursor: grab;
    user-select: none; /* 禁止文本被选中 */
  }

  .scrollable-div:active {
    cursor: grabbing;
  }

  .scrollable-div img {
    height: 100%;
    display: block;
  }
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 6px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  width: 100%;
  &Logo {
    width: 993px;
    margin: 0 auto;
    height: 77px;
    display: flex;
    &Img {
      margin-top: 20px;
      display: block;
      width: 143px;
      height: 40px;
    }
    // img {
    //   width: 40px;
    //   height: 40px;
    //   margin: 20px 10px 0 0;
    // }
    // &Title {
    //   margin-top: 23px;
    //   &Name {
    //     margin-bottom: 4px;
    //     color: rgb(51, 51, 51);
    //     font-family: Gotham;
    //     font-size: 18px;
    //     font-weight: 700;
    //     line-height: 18px;
    //     letter-spacing: -1px;
    //     text-align: left;
    //   }
    //   &Desc {
    //     color: rgb(51, 51, 51);
    //     font-family: Rubik;
    //     font-size: 12px;
    //     font-weight: 700;
    //     line-height: 12px;
    //     letter-spacing: 0px;
    //     text-align: left;
    //   }
    // }
  }
  &Header {
    border-top: 1px solid rgb(0, 0, 0);
    width: 100%;
  }
  // &Header {
  //   border-top: 1px solid rgb(0, 0, 0);
  //   height: 360px;
  //   background-image: url('https://p2.ssl.qhimg.com/t01fef2716ebc05a869.png');
  //   background-size: cover; /* 使背景图片覆盖整个容器 */
  //   background-repeat: no-repeat; /* 不重复背景图片 */
  // }
  &Brand {
    width: 993px;
    margin: 85px auto 128px;
    &Title {
      display: flex;
      height: 28px;
      align-items: center;
      margin-bottom: 36px;
      img {
        margin-right: 20px;
      }
      &Text {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
    &Desc {
      width: 993px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
      &Two {
        margin: 14px 0 43px;
      }
    }
    &Img {
      width: 1144px;
      height: 577px;
      background-image: url('https://p2.ssl.qhimg.com/t0185f899f576d7ede8.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    &Detail {
      margin: 60px 0 128px;
      width: 920px;
      display: flex;
      flex-wrap: wrap;
      gap: 39px 66px;
      &Item {
        display: flex;
        width: 427px;
        &Img {
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
        &Info {
          &Title {
            color: rgb(0, 0, 0);
            font-size: 18px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0px;
            text-align: left;
            margin-bottom: 16px;
          }
          &Desc {
            color: rgb(0, 0, 0);
            font-size: 14px;
            font-weight: 350;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: justify;
          }
        }
      }
    }
  }
  &App {
    margin: 0 auto;
    width: 993px;
    &Head {
      display: flex;
      img {
        margin-right: 20px;
      }
    }
    &Title {
      color: rgb(0, 0, 0);
      font-size: 28px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: left;
    }
    &Desc {
      margin-top: 36px;
      width: 992px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: left;
    }
    &Info {
      margin-top: 60px;
      display: flex;
      gap: 0 88px;
      &Item {
        width: 260px;
        img {
          width: 46px;
          display: block;
          margin: 0 auto;
        }
        &Title {
          margin: 25px 0 24px;
          text-align: center;
          color: rgb(0, 0, 0);
          font-size: 18px;
          font-weight: 500;
          line-height: 18px;
        }
        &Desc {
          color: rgb(0, 0, 0);
          font-size: 14px;
          font-weight: 350;
          line-height: 28px;
          text-align: justify;
        }
      }
    }
    &Btn {
      display: block;
      margin: 57px auto 124px;
      cursor: pointer;
      width: 180px;
      height: 40px;
    }
  }
  &Safe {
    margin: 0 auto;
    width: 993px;
    &Btn {
      display: block;
      margin: 0 auto 210px;
      cursor: pointer;
      width: 180px;
      height: 40px;
    }
    &Head {
      display: flex;
      &Icon {
        margin-right: 20px;
      }
      &Title {
        color: rgb(0, 0, 0);
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: left;
      }
    }
    &Desc {
      margin-top: 36px;
      width: 992px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 350;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: left;
    }
    &Info {
      display: flex;
      gap: 0 109px;
      margin: 58px 40px 51px 43px;
      width: 909px;
      &Item {
        width: 400px;
        &Head {
          display: flex;
          padding-bottom: 24px;
          margin-bottom: 24px;
          border-bottom: 1px solid rgb(0, 0, 0);
          &Icon {
            width: 18px;
            height: 18px;
            margin-right: 8px;
          }
          &Text {
            color: rgb(0, 0, 0);
            font-size: 18px;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: 0px;
            text-align: left;
          }
        }
        &Body {
          color: rgb(0, 0, 0);
          font-size: 14px;
          font-weight: 350;
          line-height: 28px;
          letter-spacing: 0px;
          text-align: justify;
        }
      }
    }
    &Process {
      margin-bottom: 66px;
      margin-left: 167px;
      display: flex;
      .specialBox {
        position: relative;
      }
      .specialText {
        position: absolute;
        right: -41px;
        width: 153px;
      }
      &Item {
        // width: 74px;
        &Box {
          width: 74px;
          height: 74px;
          background: rgb(241, 244, 251);
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &Text {
          margin-top: 21px;
          text-align: center;
          color: rgb(0, 0, 0);
          font-size: 16px;
          font-weight: 500;
          line-height: 18px;
        }
      }
      .arrow {
        display: block;
        width: 117px;
        height: 7px;
        margin: 37px 5px 0 6px;
      }
    }
  }
}
</style>
